import StartToastifyInstance from './Toastify'
import dateTimePickerInit from './custom/dateTimePickerInit'
import validatorInit from './custom/validatorInit'
import loadindInit from './custom/loading'
import {showLoading,hideLoading} from "./custom/loading";
import calcTableSize from './custom/calcTableSize'
import calcContentCardSize from "./custom/calcContentCardSize";
import tabsPageInit from './custom/tabsPageInit'
import findParent from "./custom/findParent";
import mediaAllInit from "./custom/mediaAllInit";
import mediaAllInitTx from "./custom/mediaAllInitTx";
import parentOpen from "./parentOpen";
import parentClose from "./parentClose";

import $ from 'jquery'
const CONFIRM_WRAPPER = '#admin-confirm-wraper' // 确认框

/**
 * 表格tableCheckbox()初始化
 */
function initTableCheckBox() {
  const TABLE = '.card-body table'
  const TABLE_BODY = `${TABLE} tbody`
  const ALL_CHECKBOX = `${TABLE} thead input:checkbox`
  const BODY_CHECKBOX = `${TABLE_BODY} input:checkbox`
  const BODY_CHECKBOX_CHECKED = `${BODY_CHECKBOX}:checked`
  if ($(ALL_CHECKBOX).length > 0) {
    $(ALL_CHECKBOX).click(function () {
      $(BODY_CHECKBOX).prop('checked', this.checked)
    })
    $(BODY_CHECKBOX).click(() => {
      if ($(BODY_CHECKBOX).length == $(BODY_CHECKBOX_CHECKED).length) {
        $(ALL_CHECKBOX).prop('checked', true)
      } else {
        $(ALL_CHECKBOX).prop('checked', false)
      }
    })
  }
}

/**
 * 显示确认弹窗
 * @param params
 */
function showConfirm(params) {
  let options = {
    title: '操作确认',
    showCancel: true, //是否显示取消按钮
    cancelText: '取消',//取消按钮文字
    confirmText: '确定',//确认按钮文字
    content: '确认此操作？',
    btnAlign: 'text-right'
  }
  if (typeof params === 'string') {
    options.content = params
  } else if (Object.prototype.toString.call(params) === '[object Object]') {
    options = Object.assign(options, params)
  }
/*  if(options.showCancel==false){
    options.align='text-center'
  }*/

  const BTN_CONFIRM = '#admin-confirm-wraper .btn-confirm'
  const BTN_CANCLE = '#admin-confirm-wraper .btn-cancel'
  if ($(CONFIRM_WRAPPER).length === 0) {
    $('body').append(`
      <div class="modal fade modal-action modal-confirm" id="admin-confirm-wraper" aria-labelledby="exampleModalScrollableTitle"
             aria-hidden="true" role="dialog">
      </div>
    `)
  }

  let CONTENT = `
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-body">
          <div class="row">
            <div class="iconfont icon-exclamation-circle-outlined text-warning"></div>
            <div class="col">
              <div class="modal-confirm-title mb-2">${options.title}</div>
              <div class="modal-confirm-content">${options.content}</div>
            </div>
          </div>
          <div class="modal-confirm-btns mt-3 ${options.btnAlign}">
          `
    if(options.showCancel){
      CONTENT += `<button type="button" class="btn btn-outline-gray btn-sm mr-1 btn-cancel" style="min-width: 60px" data-dismiss="modal">${options.cancelText}</button>`
    }
  CONTENT += `<button type="button" class="btn btn-primary btn-sm btn-confirm" style="min-width: 60px">${options.confirmText}</button>
          </div>
        </div>
      </div>
    </div>
  `

  $(CONFIRM_WRAPPER).html(CONTENT)
  // $(CONFIRM_WRAPPER).modal('toggle')
  $(CONFIRM_WRAPPER).modal('show')
  $(BTN_CONFIRM).click(() => {
    // eslint-disable-next-line no-unused-expressions
    options.onConfirm && options.onConfirm()
  })
  $(BTN_CANCLE).click(() => {
    options.onCancel && options.onCancel()
  })
}

/**
 * 关闭弹窗
 */
function closeConfirm() {
  $(CONFIRM_WRAPPER).modal('hide')
}

/**
 * 工具包
 */
const toolKit = {
  // 初始化事个项目
  init() {
    mediaAllInit()
    mediaAllInitTx()

    // 初始化layer，编辑页面弹窗相关内容
    // eslint-disable-next-line no-undef,no-unused-expressions,no-irregular-whitespace
    if (window.layer) {
      // eslint-disable-next-line no-undef,no-unused-expressions,no-irregular-whitespace
      window.layer.ready(() => {
        window.layerInitOk = true
      })
    }

    window.showConfirm = showConfirm
    window.closeConfirm = closeConfirm
    window.Toastify = StartToastifyInstance
    window.parentOpen = parentOpen;//不能删除
    window.parentClose = parentClose; //不能删除
    //iframe弹窗可通过此函数获得打开他的父级窗口
    window.parentWindow = function (){
      var childWindow = findParent().childWindow;
      if(childWindow&&childWindow.length){
        return childWindow[childWindow.length-1]
      } else {
        return window
      }
    }
    window.getBaseUrl = () => {
      return location.origin
    }
    window.iframeCloseLoading = function (){
      $('.iframe-loading').hide();
    }
    window.adminlte.confirm = this.confirm
    window.adminlte.closeConfirm = this.closeConfirm
    window.adminlte.toast = this.toast
    window.childWin = {
      showLoading,
      hideLoading
    }
    function _showLoad(){
      $('[data-widget="iframe"].iframe-mode .tab-content .tab-loading').show();
    }
    function _hideLoad(){
      $('[data-widget="iframe"].iframe-mode .tab-content .tab-loading').hide();
    }
    window._showLoad=_showLoad
    window._hideLoad=_hideLoad
    window.showLoading = function () {
      findParent()._showLoad()
    }
    window.mainWindow = findParent;
    window.hideLoading = function () {
      findParent()._hideLoad()
    }
    // 获取 checked 内容
    window.getCheckedItems = function (element = 'table tbody input[type=checkbox]:checked') {
      const result = []
      $(element).each(function () {
        if ($(this).val() && $(this).val() != 'on') {
          result.push($(this).val())
        }
      })
      if (result.length > 0) {
        return result.join(',')
      }
      return ''
    }

    $('table tbody td[data-width]').each(function (){
      let data = $(this).data();
      if(data.width){
        let width = parseInt(data.width);
        if(isNaN(width)){
          width = data.width
        } else width += 'px'
        $(this).css('max-width', width);
      }
    })

    /**
     * laui 表格选择初始化
     */
    const TABLE_SELECT_ELEM = '.table-select'
    $(TABLE_SELECT_ELEM).each(function (){
      var $elem = $(this);
      if($elem.siblings('.input-clear').length == 0){
        var realValue = $elem.attr('ts-selected')
        if(realValue){
          $elem.after('<span class="input-clear" style="display: inline;">×</span>')
        } else {
          realValue = ''
          $elem.after('<span class="input-clear">×</span>')
        }
        var name = $elem.data('submitName')
        var submitElement = '';
        if(name){
          submitElement = 'input[name=' + name + ']';
          if($(submitElement).length==0){
            $elem.after(`<input type="hidden" name="${name}" value="${realValue}">`)
          }
        }

        $elem.siblings('.input-clear').click(function (){
          $elem.val('')
          $elem.attr('ts-selected','')
          if(submitElement){
            $(submitElement).val('')
          } else {
            if($elem.siblings('input[type=hidden]').length==1){
              $elem.siblings('input[type=hidden]').val('')
            }
          }
          $(this).hide()
        })
      }
    })

    /**
     * 表格中 checked 值
     */
    /* window.getCheckedItems = function(element){
      let items = 'input[type=checkbox]'
      let result = []

    } */
    $(window).resize(() => {
      calcTableSize()
      tabsPageInit()
      calcContentCardSize()
    })

    $(() => {

      // 表格checkbox初始化调用
      if ($.fn.select2) {
        // todo select2 初始化赋值
        $('.select2').each(function (){
          let data = $(this).data();
          let config = {
            language: 'zh-CN'
          }
          let multiple = data.multiple || $(this).attr('multiple')
          if(multiple){
            config.multiple = true
          }
          if(data.value){
            if(multiple){
              if (typeof data.value == 'string') {
                let value = data.value.split(',');
                $(this).select2(config).val(value).trigger("change");
              } else {
                $(this).select2(config).val([data.value]).trigger("change");
              }
            } else {
              $(this).select2(config).val(data.value).trigger("change");
            }
          } else {
            $(this).select2(config);
          }
        })

        $('.select2').on('select2:select', e => {
          const { data } = e.params
          const select = $(data.element).closest('select')
          if(select.valid){
            select.valid()
          }
        })
        $('.select2').on('select2:unselect', e => {
          const { data } = e.params
          const select = $(data.element).closest('select')
          if(select.valid){
            const valid = select.valid()
            if (!valid) {
              select.siblings('.select2-container').find('.select2-selection').addClass('is-invalid')
            }
          }
        })
      }

      $('.page-wrapper').Paging()
      validatorInit() // 表单验证初始化
      initTableCheckBox()
      dateTimePickerInit()
      calcContentCardSize()
      tabsPageInit()
      // 弹窗页面内容初始化
      /*if ($.fn.overlayScrollbars) {
        $('.card-page .card-body').overlayScrollbars({})
      }*/
      $('.card-page .card-body').css('overflow-y', 'scroll');
      setTimeout(function () {
        if (!window.ignoreTableInit) {
          calcTableSize()
        }
        window.hideLoading()
      }, 100)
    })
  },
  /*editInit() {
    $('.card-page .card-body').overlayScrollbars({})
  },*/
  /**
   * toast 方法
   * @param params {object/string}
   *    string: 要弹出的文字
   *    object:
   *      text: {string} 要显示的文字
   *      duration: {number} 显示时长
   *      type: {string} success, fail 功能暂未加
   */
  toast(params) {
    let options = {}
    if (typeof params == 'string' || typeof params == 'number') {
      options.text = params
    } else if (Object.prototype.toString.call(params) === '[object Object]') {
      options = params
    } else {
      return
    }

    findParent().Toastify(options).showToast()
  },
  /**
   * 打开确认弹窗
   */
  confirm(params) {
    findParent().showConfirm(params)
  },
  /**
   * 关闭确认弹窗
   */
  closeConfirm() {
    findParent().closeConfirm()
  },
  datePickerLocale: {
    format: 'YYYY-MM-DD',
    separator: ' 至 ',
    applyLabel: '确定',
    cancelLabel: '取消',
    fromLabel: 'From',
    toLabel: 'To',
    customRangeLabel: 'Custom',
    weekLabel: 'W',
    daysOfWeek: [
      '日',
      '一',
      '二',
      '三',
      '四',
      '五',
      '六'
    ],
    monthNames: [
      '一月',
      '二月',
      '三月',
      '四月',
      '五月',
      '六月',
      '七月',
      '八月',
      '九月',
      '十月',
      '十一月',
      '十二月'
    ],
    firstDay: 0
  }
}

export default toolKit
